import { Space, Tabs } from 'antd'

import { BitazzaText } from '../../../components'
import { Rules } from './Rules/Rules'
import { Tiers } from './Tiers/Tiers'
import Style from './Tabs.module.scss'
import { useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { appCallbackHandler } from '../../../util/AppCallbackHandler'
import { useTranslation } from 'react-i18next'

interface Props {
    season?: Season
}

export const SeasonTabs: React.FC<Props> = ({ season }) => {
    const { t } = useTranslation()
    const [activeKey, setActiveKey] = useState<string>('tier')
    const [searchParams] = useSearchParams()
    const [region, setRegion] = useState<'th' | 'gl'>()

    const activeKeyHandler = (key: string) => {
        setActiveKey(key)
    }

    useEffect(() => {
        if (searchParams.get('tab') === 'rules') {
            setActiveKey('rules')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams.get('tab')])

    useEffect(() => {
        const regionValue = searchParams.get('region')
        setRegion(
            regionValue === 'th' || regionValue === 'gl'
                ? regionValue
                : undefined
        )
    }, [searchParams.get('region')])

    const items = [
        {
            label: (
                <BitazzaText
                    content={t('txt_rank_tier')}
                    format="tab"
                    noWrap
                    style={{
                        fontSize:
                            t('txt_rank_tier').length > 26 ? '0.91rem' : '1rem',
                    }}
                />
            ),
            key: 'tier',
            children: (
                <Tiers
                    noMargin={searchParams.get('status') === 'running'}
                    region={region === undefined ? 'th' : region}
                />
            ),
        },
        {
            label: <BitazzaText content={t('txt_rules')} format="tab" noWrap />,
            key: 'rules',
            children: (
                <Rules
                    onChangeTab={activeKeyHandler}
                    noMargin={searchParams.get('status') === 'running'}
                    region={region === undefined ? 'th' : region}
                />
            ),
        },
    ]

    return (
        <>
            <Tabs
                items={items}
                centered
                activeKey={activeKey}
                onTabClick={(tab: string) => activeKeyHandler(tab)}
            />
            {(searchParams.get('status') === 'running' ||
                season?.status === 'running') &&
            searchParams.get('userJoined') !== 'true' ? (
                <div className={Style.container}>
                    <div className={Style.feeContainer}>
                        <Space direction="vertical">
                            <BitazzaText
                                content={t('txt_joining_fee')}
                                color="#FFFFFF"
                                letterSpacing={2}
                                bold
                            />
                            <Space>
                                <BitazzaText
                                    deletedText
                                    content={'100'}
                                    color="#86A1A1"
                                    format="t24"
                                />
                                <BitazzaText content={'BTZ'} color="#fff" />
                            </Space>
                        </Space>
                        <Space direction="vertical">
                            <BitazzaText
                                content={t('txt_limited_time')}
                                color="#B5B3AF"
                            />
                            <BitazzaText
                                textAlign="right"
                                content={t('txt_free')}
                                color="#f1d87e"
                                format="t24"
                                letterSpacing={4}
                            />
                        </Space>
                    </div>
                    <div
                        className={Style.startButton}
                        onClick={() => appCallbackHandler('startMockTrading')}
                    >
                        <BitazzaText
                            format="t18"
                            color="#000000"
                            content={t('txt_join_btn')}
                            bold
                        />
                    </div>
                </div>
            ) : null}
        </>
    )
}

export default SeasonTabs
